module.exports = __webpack_public_path__ + "img/small concert.04ba2c1f.png";